var forgotPhoneCodeController = {
    elForm: $('#forgotPhoneCodeForm'),
    forgotModalCode: $('#forgotModalPhoneCode'),
    forgotModalSetPass: $('#forgotModalSetPass'),
    code: '',
    submitting: false,
    init: function()
    {
        forgotPhoneCodeController.clearForm();
        forgotPhoneCodeController.elForm.find('.js-forgot-countdown').hide();
        forgotPhoneCodeController.code = forgotPhoneCodeController.elForm.find('.js-input-code').val();

        forgotPhoneCodeController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        forgotPhoneCodeController.elForm.find('.js-input-code').on('click change keyup blur input', function() {
            forgotPhoneCodeController.code = $(this).val().trim();

            if(forgotPhoneCodeController.code.length === 4) {
                forgotPhoneCodeController.submitForm();
            } else {
                forgotPhoneCodeController.clearForm();
            }

            return false;
        });
    },
    submitForm: function()
    {
        if (forgotPhoneCodeController.submitting) {
            return false;
        }

        if (!forgotPhoneCodeController.validateForm()) {
            forgotPhoneCodeController.showError();

            return false;
        }

        forgotPhoneCodeController.submitting = true;

        $.post(
            forgotPhoneCodeController.elForm.attr('action'),
            forgotPhoneCodeController.elForm.serialize(),
            function(data) {
                if (data.success) {
                    forgotPhoneCodeController.forgotModalSetPass.data("forgot-type", "phone");
                    forgotPhoneCodeController.forgotModalSetPass.find('.go-back-modal')
                        .data('target', '#forgotModalPhoneCode');
                    forgotPhoneCodeController.forgotModalSetPass.modal('show');
                    forgotPhoneCodeController.forgotModalSetPass.find('.js-input-username').val(
                        forgotPhoneCodeController.elForm.find('.js-input-phone-number').val()
                    );
                    forgotPhoneCodeController.forgotModalCode.modal('hide');
                    forgotPhoneCodeController.clearForm();
                } else {
                    if(data.message) {
                        forgotPhoneCodeController.forgotModalCode.find('.error-text').text(data.message);
                        forgotPhoneCodeController.showError();
                    }
                }
            }, 'json').always(function() {
                forgotPhoneCodeController.submitting = false;
            });
    },
    validateForm: function()
    {
        forgotPhoneCodeController.clearForm();
        return ($.isNumeric(forgotPhoneCodeController.code) && forgotPhoneCodeController.code.length === 4);
    },
    clearForm: function()
    {
        forgotPhoneCodeController.elForm.find('.form-group').removeClass('has-error');
        forgotPhoneCodeController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        forgotPhoneCodeController.elForm.find('.form-group').addClass('has-error');
        forgotPhoneCodeController.elForm.find('.error-text').show();
    }
};

$(function(){
    forgotPhoneCodeController.init();
});